export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getVersionList: function getVersionList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/version/get",
        method: "get",
        params: data
      });
    },
    getVersionInfo: function getVersionInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/version/getInfo",
        method: "get",
        params: data
      });
    },
    addVersion: function addVersion() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/version/create",
        method: "post",
        data: data
      });
    },
    updateVersion: function updateVersion() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/version/update",
        method: "post",
        data: data
      });
    },
    // 获取apk版本号
    getVerisonCode: function getVerisonCode() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/version/getVerisonCode",
        method: "post",
        data: data
      });
    }
  };
});